/**
 * @generated SignedSource<<6e1586c45e5cfa5394ebc0a3a30e26da>>
 * @relayHash f977fe563881123805a0fdb63471bdfa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3a8e0682af7b65b3defbbd85315673efaf3793b23993ee9a16f2a5ced09f39ae

import type { ConcreteRequest } from 'relay-runtime';
export type ContentRepresentationV2 = "atlas_doc_format" | "editor" | "editor2" | "export_view" | "plain" | "raw" | "storage" | "styled_view" | "view" | "wiki" | "%future added value";
export type MacroRendererMode = "EDITOR" | "PDF" | "RENDERER" | "%future added value";
export type multiMacroQueryQuery$variables = {
  after?: string | null;
  blocklist?: ReadonlyArray<string> | null;
  contentId: string;
  first?: number | null;
  mode?: MacroRendererMode | null;
  refetchToken?: string | null;
};
export type multiMacroQueryQuery$data = {
  readonly macros: {
    readonly nodes: ReadonlyArray<{
      readonly contentId: string;
      readonly macroId: string;
      readonly renderedMacro: {
        readonly appKey: string | null;
        readonly macroBodyStorage: string | null;
        readonly macroRenderedRepresentation: ContentRepresentationV2 | null;
        readonly mediaToken: {
          readonly token: string | null;
        } | null;
        readonly value: string | null;
        readonly webResource: {
          readonly contexts: ReadonlyArray<string | null>;
          readonly keys: ReadonlyArray<string | null>;
          readonly superbatch: {
            readonly metatags: string | null;
          } | null;
          readonly tags: {
            readonly css: string | null;
            readonly data: string | null;
            readonly js: string | null;
          } | null;
          readonly uris: {
            readonly css: ReadonlyArray<string | null> | null;
            readonly data: ReadonlyArray<string | null> | null;
            readonly js: ReadonlyArray<string | null> | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
  } | null;
};
export type multiMacroQueryQuery = {
  response: multiMacroQueryQuery$data;
  variables: multiMacroQueryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blocklist"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": "RENDERER",
  "kind": "LocalArgument",
  "name": "mode"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refetchToken"
},
v6 = [
  {
    "kind": "ScalarField",
    "name": "css"
  },
  {
    "kind": "ScalarField",
    "name": "data"
  },
  {
    "kind": "ScalarField",
    "name": "js"
  }
],
v7 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "blocklist",
        "variableName": "blocklist"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "refetchToken",
        "variableName": "refetchToken"
      }
    ],
    "concreteType": "MacroConnection",
    "kind": "LinkedField",
    "name": "macros",
    "plural": false,
    "selections": [
      {
        "concreteType": "PageInfoV2",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          },
          {
            "kind": "ScalarField",
            "name": "endCursor"
          }
        ]
      },
      {
        "concreteType": "Macro",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "macroId"
          },
          {
            "kind": "ScalarField",
            "name": "contentId"
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "mode",
                "variableName": "mode"
              }
            ],
            "concreteType": "RenderedMacro",
            "kind": "LinkedField",
            "name": "renderedMacro",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "appKey"
              },
              {
                "kind": "ScalarField",
                "name": "value"
              },
              {
                "kind": "ScalarField",
                "name": "macroRenderedRepresentation"
              },
              {
                "kind": "ScalarField",
                "name": "macroBodyStorage"
              },
              {
                "concreteType": "WebResourceDependenciesV2",
                "kind": "LinkedField",
                "name": "webResource",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "contexts"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "keys"
                  },
                  {
                    "concreteType": "SuperBatchWebResourcesV2",
                    "kind": "LinkedField",
                    "name": "superbatch",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "metatags"
                      }
                    ]
                  },
                  {
                    "concreteType": "WebResourceTagsV2",
                    "kind": "LinkedField",
                    "name": "tags",
                    "plural": false,
                    "selections": (v6/*: any*/)
                  },
                  {
                    "concreteType": "WebResourceUrisV2",
                    "kind": "LinkedField",
                    "name": "uris",
                    "plural": false,
                    "selections": (v6/*: any*/)
                  }
                ]
              },
              {
                "concreteType": "EmbeddedMediaTokenV2",
                "kind": "LinkedField",
                "name": "mediaToken",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "token"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "multiMacroQueryQuery",
    "selections": (v7/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "multiMacroQueryQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "f977fe563881123805a0fdb63471bdfa",
    "id": "3a8e0682af7b65b3defbbd85315673efaf3793b23993ee9a16f2a5ced09f39ae",
    "metadata": {},
    "name": "multiMacroQueryQuery",
    "operationKind": "query",
    "text": "query multiMacroQueryQuery($contentId:ID!,$mode:MacroRendererMode=RENDERER,$blocklist:[String!],$first:Int,$after:String,$refetchToken:String)@allowHigherTimeout{macros(contentId:$contentId,blocklist:$blocklist,first:$first,after:$after,refetchToken:$refetchToken){pageInfo{hasNextPage,endCursor},nodes{macroId,contentId,renderedMacro(mode:$mode){appKey,value,macroRenderedRepresentation,macroBodyStorage,webResource{contexts,keys,superbatch{metatags},tags{css,data,js},uris{css,data,js}},mediaToken{token}}}}}"
  }
};
})();

(node as any).hash = "703def250fb7190af954448ab635f2f2";

export default node;
